import { Icon } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"
import { matchPath } from "react-router-dom"

import LayoutWithSidebar, { SidebarItem } from "Catalog/shared/components/LayoutWithSidebar"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"

interface GridLayoutProps {
  toolbar: JSX.Element
  main: JSX.Element | null
  none: string
  testId?: string
}

const GridLayout = ({ toolbar, main, none, testId }: GridLayoutProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()

  const { catalogNavigation } = useCatalogNavigation()

  const match = (path: string) => matchPath({ path, end: false }, window.location.pathname) !== null

  const sidebarItems: Array<SidebarItem> = [
    {
      icon: <Icon code="west" />,
      text: t("general.back_to_edit"),
      action: () => navigate(catalogNavigation.editLastVisitedPath()),
      isActive: false,
    },
    {
      text: t("sidebar.skus.text"),
      shortcutLetter: t("sidebar.skus.shortcut"),
      action: () => navigate(catalogNavigation.gridLastVisitedPath("skus")),
      isActive: match("/catalogs/:catalog_id/grid/skus"),
    },
    {
      text: t("sidebar.options.text"),
      shortcutLetter: t("sidebar.options.shortcut"),
      action: () => navigate(catalogNavigation.gridLastVisitedPath("options")),
      isActive: match("/catalogs/:catalog_id/grid/options"),
    },
    {
      text: t("sidebar.deals.text"),
      shortcutLetter: t("sidebar.deals.shortcut"),
      action: () => navigate(catalogNavigation.gridLastVisitedPath("deals")),
      isActive: match("/catalogs/:catalog_id/grid/deals"),
    },
  ]

  return (
    <LayoutWithSidebar
      toolbar={toolbar}
      sidebarItems={sidebarItems}
      main={main}
      none={none}
      displayMode="grid"
      testId={testId}
      topPadding={false}
    ></LayoutWithSidebar>
  )
}

export default GridLayout
